import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';
import api from './api-urls.js';
import Cookies from 'js-cookie'
import {
	Toast
} from 'vant';
Vue.use(Toast);
let util = {};

util.getOpenidAndCheckBind = function() {
	console.log(this.urlget('code'));
	let cookieOpenid = Cookies.get("openid");
	if(cookieOpenid) { //判断cookie里是否有openid
		this.$store.commit("setOpenid", cookieOpenid);
		this.userbind(cookieOpenid);
	} else {
		let _this = this;
		let param = qs.stringify({
			appid: "wx51648b26d76ade67",
			secret: "a0c6fd977a4ca02fde18c5458c77b2cd",
			code: this.urlget('code')
		})
		axios.post(api.BASE_URL + api.accessToken, param, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			}
		}).then((res) => {
			console.log(res)
			if(res) {
				_this.$store.commit("setOpenid", res.data.openid);
				this.checkBind(res.data.openid);
				Cookies.set("openid", res.data.openid, {
					expires: 7
				});
			}
		}).catch((err) => {
			Toast('服务器出错！');
		})
	}
}
util.checkBind = function(openid) {
	let param = qs.stringify({
		openid: openid
	});
	axios.post(api.BASE_URL + api.checkBind, param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
		}
	}).then((res) => {
		console.log(res)
		if(res.data.head.result == "true") { //已绑定
			this.$store.commit("setUserName", res.data.body.username);
			this.$store.commit("setAccount", res.data.body.account);
			this.$store.commit("openid", res.data.body.openid);
			this.$store.commit("setIsBind", true);
		} else { //未绑定
			this.$router.push({
				path: "/"
			});
		}
	}).catch((err) => {
		Toast('服务器出错！');
	})
}
util.urlget = function(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if(r != null) return(r[2]);
	return null;
}

export default util;


// WEBPACK FOOTER //
// ./src/common/util.js